import React, { useEffect, useState } from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

interface TopChipsProps {
    onClick: () => void;
}

const TopChips: React.FC<TopChipsProps> = ({ onClick }) => {
    const [active, setActive] = useState<boolean | null>(false);

    const handleOnClick = () => {
        if (active) {
            setActive(false);
        } else {
            setActive(true);
            onClick();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '8px',
                overflowX: 'auto',
                padding: '8px 8px 3px 8px',
                borderRadius: '15px',
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                whiteSpace: 'nowrap'
            }}
        >
            <Chip
                key="addCustomer"
                label="הוסף חדש"
                icon={<PersonAddIcon />}
                color="primary"
                onClick={() => handleOnClick()}
                sx={{
                    padding: 0.5,
                    fontWeight: 'bold',
                    color: 'black',
                    backgroundColor: active ? 'grey.300' : 'grey.100',
                    boxShadow: active ? 4 : 1
                }}
            />
        </Box>
    );
};

export default TopChips;
